import type { CategoriaSinCfdi } from '../api';

/** Código (botón, badge y Excel) y nombre de cada categoría de conciliado sin CFDI. */
export const CATEGORIAS_SIN_CFDI: { value: CategoriaSinCfdi; codigo: string; nombre: string }[] = [
  { value: 'PRESTAMO',  codigo: 'PR', nombre: 'Préstamo' },
  { value: 'INVERSION', codigo: 'IN', nombre: 'Inversión' },
];

export function categoriaSinCfdiMeta(categoria: CategoriaSinCfdi | null | undefined) {
  return CATEGORIAS_SIN_CFDI.find(c => c.value === categoria);
}
